<template>
  <div v-show="value" ref="dialog" class="act_alert_dialog">
    <img src="//vipcdn.mgtv.com/upload/20180408/close.png" class="close" @click="handleAction('cancel')"/>

    <div class="content">
      <div v-html="title" v-if="title"></div>
      <div class="submit" @click.prevent="handleAction('confirm')" v-if="button">
        {{button}}


      </div>
    </div>
  </div>
</template>
<script>
  import create from 'vant/lib/utils/create';
  import Popup from 'vant/lib/mixins/popup';
  import {setStyle} from '../../../tools/dom'

  export default create({
    name: 'ActAlertDialog',
    mixins: [Popup],
    props: {
      callback: Function,
      overlay: {
        type: Boolean,
        default: true
      },
      closeOnClickOverlay: {
        type: Boolean,
        default: false
      },
      lockOnScroll: {
        type: Boolean,
        default: true
      },
      title: {
        type: String,
        default: `<p>规则</p><p>规则</p>`
      },
      button: {
        type: String,
        default: "确认"
      }
    },
    data: function () {
      return {}
    },
    methods: {
      handleAction(action) {
        this.$emit('input', false);
        this.$emit(action);
        this.callback && this.callback(action);
      },
    },
    mounted(){
    },
    watch: {},
    computed: {}
  });
</script>


<style lang="stylus" scoped>
  @import "../../../share/mixins.styl"

  .act_alert_dialog
    padding 1.1rem .3rem .5rem .3rem
    background white
    center()
    border-radius 0.2rem
    color #717171
    position fixed !important

  .close
    position absolute
    top -.2rem
    right 0
    width .73rem
    height .84rem
    z-index 2
    box-sizing content-box
    padding .2rem

  .content
    overflow hidden
    position relative
    width 5.6rem

    .title
      width 100%
      text-align center
      font-size .4rem
      margin-bottom .4rem

    .submit
      background url(//vipcdn.mgtv.com/upload/20180408/btn.png) no-repeat
      background-size cover
      width 3.96rem
      height 1.05rem
      text-align center
      color white
      margin .4rem auto 0 auto
      font-size .36rem
      padding-top .22rem

  .inline-block
    display inline-block
</style>



// WEBPACK FOOTER //
// src/components/Popups/ActAlertDialog/ActAlertDialog.vue